import { render, staticRenderFns } from "./order_notification_trigger.vue?vue&type=template&id=66e97b97&scoped=true&"
import script from "./order_notification_trigger.vue?vue&type=script&lang=js&"
export * from "./order_notification_trigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e97b97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e97b97')) {
      api.createRecord('66e97b97', component.options)
    } else {
      api.reload('66e97b97', component.options)
    }
    module.hot.accept("./order_notification_trigger.vue?vue&type=template&id=66e97b97&scoped=true&", function () {
      api.rerender('66e97b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/order_notification/order_notification_trigger.vue"
export default component.exports